// Menu hover functionality
function initMenuHover() {
  const menuDetails = document.querySelectorAll('header details');
  
  if (menuDetails.length === 0) return;
  
  menuDetails.forEach(function(detail) {
    // Skip search details element
    if (detail.querySelector('summary[aria-label*="Search"]') || 
        detail.classList.contains('header__search') ||
        detail.id && detail.id.includes('Search')) {
      return; // Skip this one
    }
    
    let timeout;
    
    detail.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 990) {
        clearTimeout(timeout);
        this.setAttribute('open', '');
      }
    });
    
    detail.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        const self = this;
        timeout = setTimeout(function() {
          self.removeAttribute('open');
        }, 300);
      }
    });
  });
}

// Menu item visual hover effect
function initMenuHoverEffect() {
  // Top level menu items
  const menuItems = document.querySelectorAll('summary.header__menu-item, a.header__menu-item');
  
  if (menuItems.length === 0) return;
  
  menuItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 990) {
        this.style.backgroundColor = '#f4f2f2';
        this.style.color = 'black';
        this.style.transform = 'translateY(-1px)';
        this.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
        this.style.borderRadius = '5px';
        this.style.transition = 'all 0.3s ease';
      }
    });
    
    item.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        this.style.backgroundColor = '';
        this.style.color = '';
        this.style.transform = '';
        this.style.boxShadow = '';
      }
    });
  });

  // Submenu items hover effect
  const subMenuLinks = document.querySelectorAll('.header__submenu .link');
  
  subMenuLinks.forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 990) {
        this.style.backgroundColor = '#f4f2f2';
        this.style.transform = 'translateY(-1px)';
        this.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
        this.style.borderRadius = '5px';
        this.style.transition = 'all 0.3s ease';
        this.style.textDecoration = 'none';
      }
    });
    
    link.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        this.style.backgroundColor = '';
        this.style.transform = '';
        this.style.boxShadow = '';
        this.style.textDecoration = '';
      }
    });
  });
}

// Initialize menu hover effect
setTimeout(initMenuHoverEffect, 1000);
document.addEventListener('DOMContentLoaded', initMenuHoverEffect);
window.addEventListener('load', function() {
  setTimeout(initMenuHoverEffect, 500);
});

// Initialize menu hover
setTimeout(initMenuHover, 1000);
document.addEventListener('DOMContentLoaded', initMenuHover);
window.addEventListener('load', function() {
  setTimeout(initMenuHover, 500);
});

// Override Dawn's modal-opener for "Choose options" buttons
// Redirects to product page instead of opening quick-view popup
(function() {
  'use strict';
  
  // Hide the quick-add modal with CSS
  const style = document.createElement('style');
  style.textContent = `
    quick-add-modal,
    modal-dialog[id*="QuickAdd"] {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Redirect on click
  window.addEventListener('click', function(e) {
    const button = e.target.closest('.quick-add__submit, button[name="add"]');
    
    if (button && button.textContent.trim() === 'Choose options') {
      const card = button.closest('.card-wrapper');
      if (card) {
        const productLink = card.querySelector('.card__heading a, .card__link, a.card-wrapper');
        
        if (productLink) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          window.location.href = productLink.href;
          return false;
        }
      }
    }
  }, true);
})();


// Block Globo tracking errors
(function() {
  'use strict';
  
  // Override Globo's tracking functions to prevent errors
  if (window.ShopifyAnalytics) {
    const originalTrack = window.ShopifyAnalytics.lib?.track;
    
    if (originalTrack) {
      window.ShopifyAnalytics.lib.track = function(eventName, properties) {
        // Block Globo's variant tracking that causes errors
        if (eventName === 'Viewed Product Variant' || 
            eventName === 'trackViewedProductVariant') {
          return; // Silently ignore
        }
        // Allow other tracking to continue
        return originalTrack.apply(this, arguments);
      };
    }
  }
  
  // Catch and suppress Globo shop_events_listener errors
  const originalError = console.error;
  console.error = function(...args) {
    const errorString = JSON.stringify(args).toLowerCase();
    
    // Block specific Globo errors
    if (errorString.includes('shop_events_listener') ||
        errorString.includes('trackviewedproductvariant') ||
        errorString.includes('findproductandvariantincollection')) {
      return; // Suppress the error
    }
    
    // Allow other errors to show
    originalError.apply(console, args);
  };
  
  // Also block warnings from Globo
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const warnString = JSON.stringify(args).toLowerCase();
    
    if (warnString.includes('shop_events_listener') ||
        warnString.includes('globo')) {
      return; // Suppress the warning
    }
    
    originalWarn.apply(console, args);
  };
})();


////////////////////remove globo
(function() {
  // Save original console methods
  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalInfo = console.info;
  const originalGroup = console.group;
  const originalGroupCollapsed = console.groupCollapsed;
  const originalGroupEnd = console.groupEnd;
  
  // Keywords to filter
  const blockedKeywords = [
    'globo',
    'product-options',
    'gpomain',
    'gpoconfigs',
    'hot reload',
    'hotreload',
    'unlimited product options',
    'storefront',
    'learn-more'
  ];
  
  // Check if message should be blocked
  function shouldBlock(args) {
    const message = JSON.stringify(args).toLowerCase();
    return blockedKeywords.some(keyword => message.includes(keyword.toLowerCase()));
  }
  
  // Override all console methods
  console.log = function(...args) {
    if (!shouldBlock(args)) originalLog.apply(console, args);
  };
  
  console.warn = function(...args) {
    if (!shouldBlock(args)) originalWarn.apply(console, args);
  };
  
  console.info = function(...args) {
    if (!shouldBlock(args)) originalInfo.apply(console, args);
  };
  
  console.group = function(...args) {
    if (!shouldBlock(args)) originalGroup.apply(console, args);
  };
  
  console.groupCollapsed = function(...args) {
    if (!shouldBlock(args)) originalGroupCollapsed.apply(console, args);
  };
  
  console.groupEnd = function(...args) {
    if (!shouldBlock(args)) originalGroupEnd.apply(console, args);
  };
})();

/*// Enhanced scroll behavior
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.shopify-section-header');
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});
*/
